import { render, staticRenderFns } from "./tablecell.vue?vue&type=template&id=28662fe0&"
import script from "./tablecell.vue?vue&type=script&lang=js&"
export * from "./tablecell.vue?vue&type=script&lang=js&"
import style0 from "./tablecell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports